// extracted by mini-css-extract-plugin
export default {"story-tags":"StoryTags_story-tags__JOZna"};